import { Component, OnInit, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-custom-date-time-control',
  templateUrl: './custom-date-time-control.component.html',
  styleUrls: ['./custom-date-time-control.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomDateTimeControlComponent),
      multi: true
    }
  ]
})
export class CustomDateTimeControlComponent implements OnInit, ControlValueAccessor {
  @Input() onlyDate?: boolean;
  public time:       string;
  public date:       string;
  public times:      string[] = Array(24).fill(0).map((x, i) => i.toString());
  public disabled:   boolean;

  private propagateChange: (_: any) => {};
  private propagateTouched: () => {};

  constructor() { }

  ngOnInit() {
  }

  writeValue(obj) {
    // Pass new value from form model down to DOM elements
    this.timeSetter(obj);
  }

  registerOnChange(fn) {
    // Callback to pass value from UI up to form model
    this.propagateChange = fn;
  }

  registerOnTouched(fn) {
    // Callback to pass touch status from UI up to form model
    this.propagateTouched = fn;
  }

  public onBlur() {
    this.propagateTouched();
  }

  private dateTimeBuilder(date: string, time: string): string {
    time = time.substring(0, 2);
    return `${date}T${time}:00:00`;
  }

  private timeSetter(dateTime: string): void {
    if (dateTime) {
      let date: string = dateTime.substring(0, 10);
      let time: string = dateTime.substring(11, 13) + ':00';
      this.date = date;
      this.time = time;
    } else {
      this.date = null;
      this.time = null;
    }
  }

  public buildDate(date: string, time: string): void {
    if (date && !time) {
      let midnightTime = '00:00';
      this.time = midnightTime;
      this.propagateChange(this.dateTimeBuilder(date, midnightTime));
    } else if (date && time) {
      this.propagateChange(this.dateTimeBuilder(date, time));
    } else {
      this.propagateChange(null);
    }
  }

  public setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/group/group-settings/custom-date-time-control/custom-date-time-control.component.ts